import { Button, Modal } from 'antd';

const SplitUpdateConfirmModal = ({ open, mode, onOk, onCancel }) => (
  <Modal
    title="Transakcija razdeljena med projekte - Potrdi spremembe"
    open={open}
    onCancel={onCancel}
    footer={[
      <Button key="cancel" onClick={onCancel}>Prekliči</Button>,
      <Button key="ok" type="primary" onClick={onOk}>Potrdi</Button>,
    ]}
  >
    <p>
      {mode === 'master'
        ? 'Spremembe bodo uporabljene za VSE vrstice razdelitve. Zneski po projektih bodo preračunani po deležih.'
        : 'Spremembe bodo uporabljene SAMO za to vrstico razdelitve. Master in ostale vrstice ostanejo nespremenjeni.'}
    </p>
  </Modal>
);

export default SplitUpdateConfirmModal;
